module.exports = __webpack_public_path__ + "img/hk_quotaIcon.b3141afa.png";